import { render, staticRenderFns } from "./GiftListService.vue?vue&type=template&id=7181d0ab&scoped=true&"
import script from "./GiftListService.vue?vue&type=script&lang=js&"
export * from "./GiftListService.vue?vue&type=script&lang=js&"
import style0 from "./GiftListService.vue?vue&type=style&index=0&id=7181d0ab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7181d0ab",
  null
  
)

export default component.exports